import React from "react";
import { RefundRequestStatus as RefundRequestStatusType } from "../../../common/types";
import { formatRefundRequestStatus } from "../../utils";
import "./refund-request-status.scss";

interface RefundRequestStatusProps {
  status: RefundRequestStatusType;
}

export const RefundRequestStatus: React.FC<RefundRequestStatusProps> = ({ status }) => {
  return (
    <span className={`refund-request-status refund-request-status--${status}`}>
      {formatRefundRequestStatus(status)}
    </span>
  );
};
